var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-baseMultiSelect"},[_c('div',{staticClass:"baseMultiSelectList"},[_vm._t("default",[_vm._v("This is the multi select slot")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }